import { formatDate } from "@watcherr/ui";
import { downloadAsBlob, formatDateTimeExport } from "~utils/export";
import { fetchLocationStatSessions } from "./location-stats.api";
import { t } from "~i18n";

export async function exportSessions(profileId: number, start: Date, end: Date) {
  const sessions = await fetchLocationStatSessions(profileId, start, end)
  const header = [
    "timestamp",
    "zone",
    "plane",
    "category",
    "duration-in-seconds"
  ].join(", ")
  const rows = sessions.map(s => {
    return [
      formatDateTimeExport(new Date(s.timestamp)),
      s.zoneName,
      s.planeName,
      t(`zone.category.${s.category}`),
      s.seconds,
    ].join(", ")
  })
  const data = [header, ...rows].join("\n")
  downloadAsBlob(`resident-${profileId}-sessions-export-${formatDate(start)}-${formatDate(end)}`, data)
}
